/**
 * Registry of available emulator cores
 * Defines metadata for each core implementation
 */

import { EmulatorCoreType } from './EmulatorCoreFactory';

export interface CoreRegistryEntry {
  type: EmulatorCoreType;
  displayName: string;
  description: string;
  recommended: boolean;
  requiresHeaders: boolean; // COOP/COEP
  stability: 'stable' | 'experimental' | 'unstable';
}

export const CORE_REGISTRY: CoreRegistryEntry[] = [
  {
    type: EmulatorCoreType.DESMOND,
    displayName: 'Desmond (DeSmuME)',
    description: 'Stable, lightweight, works on all browsers. Custom key bindings and cloud saves supported.',
    recommended: true,
    requiresHeaders: false,
    stability: 'stable',
  },
  {
    type: EmulatorCoreType.MELONDS,
    displayName: 'melonDS',
    description: 'High accuracy with custom controls and cloud saves. WARNING: Memory leak (12GB RAM usage).',
    recommended: false,
    requiresHeaders: true, // Requires SharedArrayBuffer
    stability: 'unstable',
  },
];

/**
 * Get registry entry for a core type
 */
export function getCoreInfo(type: EmulatorCoreType): CoreRegistryEntry | undefined {
  return CORE_REGISTRY.find(entry => entry.type === type);
}

/**
 * Get recommended core
 */
export function getRecommendedCore(): EmulatorCoreType {
  const recommended = CORE_REGISTRY.find(entry => entry.recommended);
  return recommended?.type || EmulatorCoreType.DESMOND;
}
